module.exports = __webpack_public_path__ + "media/images/cards-cded2f874d61df1860c0009f7b0a051e.png";